import {isNullish} from 'schemaDefinition/functions/isNullish';

/**
 * Value is considered empty if it is:
 * - null
 * - undefined
 * - empty string
 * - empty array
 * TODO: Consider empty object as well
 */
export const isEmptyValue = (value: unknown | null | undefined): boolean => {
  return (
    isNullish(value) ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  );
};
